// CustomerOutreach.jsx

import React, { useState } from "react";
import "./CustomerOutreach.css";

import {
  FaEnvelope,
  FaSms,
  FaWhatsapp,
  FaUsers,
  FaEye,
  FaPaperPlane,
  FaRegSave,
} from "react-icons/fa";

const emailTemplates = [
  "Welcome Template",
  "Promotion Template",
  "Newsletter Template",
];

const whatsappTemplates = [
  "Order Update",
  "Welcome Message",
  "Payment Reminder",
];

const templates = [
  {
    id: 1,
    name: "Modern",
    bg: "#f5f7ff",
    color: "#222",
  },
  {
    id: 2,
    name: "Dark",
    bg: "#1e1e1e",
    color: "#fff",
  },
  {
    id: 3,
    name: "Promotional",
    bg: "#fff4e5",
    color: "#d35400",
  },
];

const CustomerOutreach = () => {
  const [campaignType, setCampaignType] = useState("email");
  const [audience, setAudience] = useState("all");

  const [title, setTitle] = useState("");
  const [subject, setSubject] = useState("");
  const [content, setContent] = useState("");

  const [selectedTemplate, setSelectedTemplate] = useState(templates[0]);

  // EMAIL
  const [emailTemplate, setEmailTemplate] = useState("");

  // WHATSAPP
  const [whatsappTemplate, setWhatsappTemplate] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [orderId, setOrderId] = useState("");
  const [date, setDate] = useState("");

  return (
    <div className="campaignStudio">
      {/* HEADER */}
      <div className="topHeader">
        <div>
          <h1>Campaign Studio</h1>
          <p>Create and manage marketing campaigns</p>
        </div>

        <button className="sendBtn">
          <FaPaperPlane />
          Send Campaign
        </button>
      </div>

      <div className="mainGrid">
        {/* LEFT SIDE */}
        <div className="leftPanel">

          {/* Campaign Type */}
          <div className="cardBox">
            <h2>Campaign Type</h2>

            <div className="typeGrid">

              <button
                className={`typeBtn ${
                  campaignType === "email" ? "activeBlue" : ""
                }`}
                onClick={() => setCampaignType("email")}
              >
                <FaEnvelope />
                <span>Email</span>
              </button>

              <button
                className={`typeBtn ${
                  campaignType === "sms" ? "activeGreen" : ""
                }`}
                onClick={() => setCampaignType("sms")}
              >
                <FaSms />
                <span>SMS</span>
              </button>

              <button
                className={`typeBtn ${
                  campaignType === "whatsapp"
                    ? "activeWhatsapp"
                    : ""
                }`}
                onClick={() => setCampaignType("whatsapp")}
              >
                <FaWhatsapp />
                <span>WhatsApp</span>
              </button>

            </div>
          </div>

          {/* Audience */}
          <div className="cardBox">
            <h2>Audience Selection</h2>

            <div className="audienceGrid">

              {[
                "all",
                "selected",
                "premium",
                "inactive",
              ].map((item) => (
                <button
                  key={item}
                  onClick={() => setAudience(item)}
                  className={`audienceBtn ${
                    audience === item
                      ? "selectedAudience"
                      : ""
                  }`}
                >
                  <FaUsers />
                  {item} Users
                </button>
              ))}

            </div>
          </div>

          {/* CAMPAIGN DETAILS */}
          <div className="cardBox">
            <h2>Campaign Details</h2>

            {/* EMAIL FORM */}
            {campaignType === "email" && (
              <div className="formGroup">

                <input
                  type="text"
                  placeholder="Campaign Title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />

                <select
                  value={emailTemplate}
                  onChange={(e) =>
                    setEmailTemplate(e.target.value)
                  }
                >
                  <option value="">
                    Select SendGrid Template
                  </option>

                  {emailTemplates.map((template, index) => (
                    <option key={index}>
                      {template}
                    </option>
                  ))}
                </select>

                <input
                  type="text"
                  placeholder="Email Subject"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                />

                <textarea
                  rows={7}
                  placeholder="Write email content..."
                  value={content}
                  onChange={(e) => setContent(e.target.value)}
                />

                <input
                  type="text"
                  placeholder="CTA Button Text"
                />

              </div>
            )}

            {/* SMS FORM */}
            {campaignType === "sms" && (
              <div className="formGroup">

                <input
                  type="text"
                  placeholder="Campaign Title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />

                <textarea
                  rows={5}
                  maxLength={160}
                  placeholder="Write SMS content..."
                  value={content}
                  onChange={(e) => setContent(e.target.value)}
                />

                <span className="characterCount">
                  {content.length}/160 Characters
                </span>

              </div>
            )}

            {/* WHATSAPP FORM */}
            {campaignType === "whatsapp" && (
              <div className="formGroup">

                <input
                  type="text"
                  placeholder="Campaign Title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />

                <select
                  value={whatsappTemplate}
                  onChange={(e) =>
                    setWhatsappTemplate(e.target.value)
                  }
                >
                  <option value="">
                    Select WhatsApp Template
                  </option>

                  {whatsappTemplates.map((template, index) => (
                    <option key={index}>
                      {template}
                    </option>
                  ))}
                </select>

                <input
                  type="text"
                  placeholder="Customer Name Variable"
                  value={customerName}
                  onChange={(e) =>
                    setCustomerName(e.target.value)
                  }
                />

                <input
                  type="text"
                  placeholder="Order ID Variable"
                  value={orderId}
                  onChange={(e) =>
                    setOrderId(e.target.value)
                  }
                />

                <input
                  type="text"
                  placeholder="Date Variable"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                />

              </div>
            )}
          </div>

          {/* TEMPLATE SECTION */}
          {campaignType !== "sms" && (
            <div className="cardBox">
              <h2>Choose Template Design</h2>

              <div className="templateGrid">

                {templates.map((template) => (
                  <div
                    key={template.id}
                    className={`templateCard ${
                      selectedTemplate.id === template.id
                        ? "selectedTemplate"
                        : ""
                    }`}
                    onClick={() =>
                      setSelectedTemplate(template)
                    }
                  >
                    <div
                      className="templatePreview"
                      style={{
                        background: template.bg,
                        color: template.color,
                      }}
                    >
                      {template.name}
                    </div>

                    <button>
                      Use Template
                    </button>
                  </div>
                ))}

              </div>
            </div>
          )}

          {/* ACTION BUTTONS */}
          <div className="actionButtons">

            <button className="draftBtn">
              <FaRegSave />
              Save Draft
            </button>

            <button className="sendBtn">
              <FaPaperPlane />
              Send Campaign
            </button>

          </div>
        </div>

        {/* RIGHT PREVIEW */}
        <div className="previewPanel">

          <div className="previewHeader">
            <h2>Live Preview</h2>

            <div className="liveText">
              <FaEye />
              Real Time
            </div>
          </div>

          <div
            className="previewBox"
            style={{
              background: selectedTemplate.bg,
              color: selectedTemplate.color,
            }}
          >

            <span className="previewType">
              {campaignType}
            </span>

            <h3>
              {title || "Campaign Title"}
            </h3>

            {/* EMAIL PREVIEW */}
            {campaignType === "email" && (
              <div className="emailPreview">

                <p className="emailSubject">
                  {subject || "Email Subject"}
                </p>

                <div className="previewContent">
                  {content ||
                    "Your email content preview appears here"}
                </div>

                <button className="ctaBtn">
                  Learn More
                </button>

              </div>
            )}

            {/* SMS PREVIEW */}
            {campaignType === "sms" && (
              <div className="smsPreview">

                {content ||
                  "Your SMS preview appears here"}

              </div>
            )}

            {/* WHATSAPP PREVIEW */}
            {campaignType === "whatsapp" && (
              <div className="whatsappPreview">

                <div className="waBubble">

                  Hello{" "}
                  {customerName || "John"},
                  <br />
                  <br />

                  Your order #
                  {orderId || "12345"} has been
                  shipped.
                  <br />
                  <br />

                  Delivery Date:
                  {" "}
                  {date || "Tomorrow"}

                </div>

              </div>
            )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerOutreach;